<div class="bulk-pending-users-container">
  <div class="mb-3 flex align-items-center gap-3">
    <p-dropdown
      [options]="statusOptions"
      [(ngModel)]="selectedStatus"
      optionLabel="label"
      optionValue="value"
      (onChange)="onStatusChange()"
      placeholder="Select Status"
      [style]="{'min-width': '180px'}"
    ></p-dropdown>
    <p-button
      icon="pi pi-refresh"
      class="p-button-text"
      [style]="{'font-size': '1.2rem'}"
      [rounded]="true"
      (onClick)="onRefresh()"
      pTooltip="Refresh"
      tooltipPosition="top"
    ></p-button>
  </div>
  @if(pendingBulkUserList && pendingBulkUserList.length){
    <p-table
    [value]="pendingBulkUserList"
    [paginator]="true"
    [rows]="limit"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onLazyLoad)="fetchPendingBulkUsers($event)"
    [responsiveLayout]="'scroll'"
    styleClass="p-datatable-sm p-datatable-sm--normal"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          @if(isPWCEnabled){
              <th>PWC Email</th>
          }
          <th>Phone</th>
          @if (fieldExistInObject('jobTypes')) {
              <ng-container>
                <th>Job Types</th>
              </ng-container>
          }
          @if(isPWCEnabled){
              <th>Standard pay rate</th>
              @if (fieldExistInObject('secondaryPayRate')) {
                <th>Foreign language rate</th>
              }
              <th>Ranking</th>
              <th>GUID</th>
              <th>Contractor Number</th>
              @if (fieldExistInObject('secondaryContractorNumber')) {
                <th>Secondary Contractor Number</th>
              }
          }
          <th>Rating</th>
          <th>Status</th>
          <th>Created At</th>
          @if(bulkConstants.failed === selectedStatus){
            <th>Reason</th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ user.firstName }}</td>
          <td>{{ user.lastName }}</td>
          <td>{{ user.email }}</td>
          @if(isPWCEnabled){
              <td>{{ user.pwcEmail }}</td>
          }
          <td>{{ user.phone }}</td>
            @if (fieldExistInObject('jobTypes')) {
              <td>
                <ng-container>
                  {{ user.jobTypes.join(', ') }}
                </ng-container>
              </td>
            }
          @if(isPWCEnabled){
              <td>{{ user.primaryPayRate }}</td>
              @if (fieldExistInObject('secondaryPayRate')) {
                <td>{{ user.secondaryPayRate }}</td>
              }
              <td>{{ user.ranking }}</td>
              <td>{{ user.guid }}</td>
              <td>{{ user.contractorNumber }}</td>
              @if (fieldExistInObject('secondaryContractorNumber')) {
                <td>{{ user.secondaryContractorNumber || '-' }}</td>
              }
          }
          <td>{{ user.rating }}</td>
          <td>
              @if(bulkConstants.inProgress === user.status){
                  <i pTooltip="In Progress" class="pi pi-clock orange mr-2" style="font-size: 1rem;"></i>
              } @else if(bulkConstants.published === user.status){
                  <i pTooltip="Invite sent successfully" class="pi pi-check-circle freshgreen mr-2" style="font-size: 1rem;"></i>
              } @else if(bulkConstants.failed === user.status){
                <i pTooltip="Failed to send invite" class="pi pi-times-circle p-error mr-2" style="font-size: 1rem;"></i>
              }
          </td>
          <td>{{ user.createdAt | date: 'short' }}</td>
          @if(bulkConstants.failed === selectedStatus){
            <td>{{user.reason || 'N/A'}}</td>
          }
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <div>
      No records found
    </div>
  }
</div>
